import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-miterlimit": "10",
  viewBox: "0 0 41.77 41.77"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "Layer 2" }, [
      _createElementVNode("g", { "data-name": "Layer 1" }, [
        _createElementVNode("path", { d: "m3 3 35.77 35.77M38.77 3 3 38.77" })
      ])
    ], -1)
  ]))]))
}
export default { render: render }